/**
 * Adding an organizationID here hides the variant inventory editor and available column.
 * Keep IDs as strings because the selected organization ID comes from the route.
 */
export const VARIANT_INVENTORY_HIDDEN_ORGANIZATION_IDS: ReadonlySet<string> = new Set([
  '356030', // Soccer Shots Testing
  '383015', // Soccer Shots Production
]);
